import { AppConfig } from '../app/model/app-config';

export const environment: AppConfig = {
    production: false,
    apiUri: null,
    identityUri: null,
    backofficeIdentityUri: null,
    tokyoIdentityUri: null,
    niigataIdentityUri: null,
    googleApiKey: null,
    allowLinksToCms: false,
    analyticsUri: null,
    addressServiceUri: null,
    checkDuplicatedRegistrations: true,
    proposeAlternateCommunities: true,
    showLocationSelectors: true,
    aiConnectionString: ''
};
